import {Component, OnInit} from '@angular/core';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-start-component',
  templateUrl: './start-component.component.html',
  styleUrls: ['./start-component.component.css'],
  animations: [
    trigger('quickFadeIn', [
      // ...
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({
        opacity: 0,
        display: 'none'
      })),
      transition('* => open', [
        animate('200ms', keyframes([
          style({display: 'block'}),
          style({opacity: 0}),
          style({opacity: 1})
        ]))
      ]),
      transition('* => closed', [
        animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0}),
          style({display: 'none'})
        ]))
      ])
    ])
  ]
})
export class StartComponentComponent implements OnInit {
  location: any = 0;
  email: string;
  mailingListPopupState = 'closed';

  needsLocationPermissions = 'open';
  checkFailed = false;

  constructor(private router: Router, private http: HttpClient) {
  }

  ngOnInit(): void {

    this.checkLocation();

  }

  checkLocation(check?): void {
    this.checkFailed = false;
    navigator.geolocation.getCurrentPosition(position => {
      console.log('success', position);
      this.needsLocationPermissions = 'closed';
    }, positionError => {
      console.log('error', positionError);
      this.needsLocationPermissions = 'open';
      if (check) {
        setTimeout(() => {
          this.checkFailed = true;
        }, 500);
      }
    }, {enableHighAccuracy: true});
  }

  noThanks(): void {
    this.router.navigate(['section', '1', this.location]);
  }

  signup(): void {

    const API_KEY = 'dbd1125fa1a540fbb289d9f79bf226e1-us13';
    const AUDIENCE_ID = '0a21b55a75';
    const SEND_WELCOME = true;
    // subscriber details

    const URL = 'https://us13.api.mailchimp.com/2.0/lists/subscribe.json?apikey=' + API_KEY + '&id=' + AUDIENCE_ID + '&email[email]=' + this.email + '&double_optin=false&send_welcome=' + SEND_WELCOME;
    // call HTTP get request
    this.http.get(URL).subscribe((success) => {
      console.log('success', success);
      this.router.navigate(['section', '1', this.location]);
    }, (error) => {
      console.log('error', error);
      this.router.navigate(['section', '1', this.location]);
    });


  }

  process(): void {
    this.mailingListPopupState = 'open';

  }

}
